module.exports = ".tabs {\n  height: 50px;\n  line-height: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  background: red;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap; }\n  .tabs > div {\n    -ms-flex: 1;\n        flex: 1;\n    text-align: center;\n    background: #E7EEF0;\n    color: #2B3B42;\n    font-size: 12px;\n    cursor: pointer;\n    overflow: hidden; }\n  .tabs > div.active, .tabs > div:hover {\n    background: #E7EEF0;\n    color: #FE763A;\n    border-bottom: 3px solid #FE763A; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/tabs/tabs.component.scss
// module id = 707
// module chunks = 1